// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"ce9334c9","255":"9366fca8","787":"44a1946b"}[chunkId] + ".chunk.js";
};